module.exports = __webpack_public_path__ + "static/android-icon-192x192-087e7c177e53c07b2a9601165b447736.png";